import { render, staticRenderFns } from "./payWechat.vue?vue&type=template&id=bf6c5fbe&scoped=true&"
import script from "./payWechat.vue?vue&type=script&lang=js&"
export * from "./payWechat.vue?vue&type=script&lang=js&"
import style0 from "./payWechat.vue?vue&type=style&index=0&id=bf6c5fbe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf6c5fbe",
  null
  
)

component.options.__file = "payWechat.vue"
export default component.exports